module.exports = __webpack_public_path__ + "static/media/dev-core-services.d4020d2b.png";